import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';
import type { ReactNode } from 'react';

interface GlassCardProps {
    children: ReactNode;
    className?: string;
    gradient?: boolean;
    delay?: number;
}

export default function GlassCard({
    children,
    className,
    gradient = false,
    delay = 0
}: GlassCardProps) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.5, delay }}
            className={cn(
                "bg-white/[0.03] backdrop-blur-lg border border-white/[0.08] transition-all duration-300 hover:bg-white/[0.05] hover:border-white/[0.12] hover:shadow-[0_8px_32px_rgba(0,0,0,0.3)] rounded-2xl p-6 relative overflow-hidden group",
                gradient && "bg-gradient-to-br from-white/[0.08] to-white/[0.02]",
                className
            )}
        >
            {/* Subtle shine effect on hover */}
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none">
                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white/[0.1] via-transparent to-transparent" />
            </div>

            {/* Content */}
            <div className="relative z-10">
                {children}
            </div>
        </motion.div>
    );
}
